import { Group, Text } from "@mantine/core";

const CardInfo = (props: { label: string, value: string }) => {
    return(
        <Group justify="space-between">
            <Text fw={600}>{ props.label }:</Text>
            <Text style={{ opacity: .5 }}>{ props.value }</Text>
        </Group>
    );
};

export default CardInfo;